/**
 * Created by Administrador on 22/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('postCheckInPassageAnnulment', {
                parent: 'app',
                url: '/postCheckInPassageAnnulment',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/passages/reportPassages.html',
                        controller: 'reportPassagesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['reportPassages']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassages('postCheckInPassageAnnulment')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type:[function(){
                                return 'postCheckInPassageAnnulment';
                            }],
                            airports:[function(){
                                return [];
                            }]
                        }
                    }
                }
            })
            .state('postCheckInAnnulment', {
                parent: 'app',
                url: '/postCheckInAnnulment',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/passages/reportPassages.html',
                        controller: 'reportPassagesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['reportPassages']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassages('postCheckInAnnulment')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type:[function(){
                                return 'postCheckInAnnulment';
                            }],
                            airports:[function(){
                                return [];
                            }]
                        }
                    }
                }
            })
            .state('airportTax', {
                parent: 'app',
                url: '/airportTax',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/passages/reportPassages.html',
                        controller: 'reportPassagesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['reportPassages']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabPassages('airportTax')
                            }],
                            userSession:['userService',function(userService){
                                return userService.getSession(true);
                            }],
                            type:[function(){
                                return 'airportTax';
                            }],
                            airports:['airportService',function(airportService){
                                return airportService.getAirportsActiveDisable(true);
                            }]
                        }
                    }
                }
            });
    }
})();
